import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {AlertService, ConstantService} from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { CompareReservationLedgerService } from '../compare-reservation-ledger.service';
import { CompareReservationLedger } from '../compare-reservation-ledger';
import { ReservationService } from '@app/_components/reservation/reservation.service';
import {
	OrderDetailListComponent
} from "@app/_components/reservation/components/reservation/order-detail/order-detail-list/order-detail-list.component";
import {
	ReservationLedgerListComponent
} from "@app/_components/reservation/components/reservation-ledger/reservation-ledger-list/reservation-ledger-list.component";
import {environment} from "@environments/environment";
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ReportService } from '@app/_components/report';
import { ImportExportComponent } from '@app/_components/_helpers/import-export/import-export.component';

@Component({
    selector: 'app-compare-reservation-ledger-list',
    templateUrl: './compare-reservation-ledger-list.component.html',
    styleUrls: ['./compare-reservation-ledger-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class CompareReservationLedgerListComponent implements OnInit {

	@ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;
	reservations: any[]=[];
	reservationStatuses: any[];
	reservationStatus1: any;
	constructor(
		private compareReservationLedgerService: CompareReservationLedgerService,
		private alertService: AlertService,
		private messageService: MessageService,
		private reservationService: ReservationService,
		private formBuilder: UntypedFormBuilder,
		private reportService: ReportService,
		public constantService: ConstantService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = compareReservationLedgerService.statuses;
		this.reservationStatuses = this.reservationService.reservationStatuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	compareReservationLedgers: any;
	compareReservationLedger: CompareReservationLedger;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;
	form1: UntypedFormGroup;

	shortTermRentals: any;
	minDate: any = new Date();

	statuses: any;

	columns: any[] = [
		{ field: 'propertyCode', header: 'Property', width: 'auto' },
		{ field: 'createDate', header: 'Create-Date', width: 'auto' },
		{ field: 'orderId', header: 'OrderId', width: 'auto' },
		{ field: 'reservationId', header: 'ReservationId', width: 'auto' },
		{ field: 'reservationStatus', header: 'Status', width: 'auto' },
		{ field: 'guestName', header: 'Guest Name', width: 'auto' },
		{ field: 'checkInDate', header: 'Check-In-Date', width: 'auto' },
		{ field: 'checkOutDate', header: 'Check-Out-Date', width: 'auto' },
		{ field: 'invoiceTotal', header: 'Invoice Total', width: 'auto' },
		{ field: 'ledgerTotal', header: 'Ledger Total', width: 'auto' },
		{ field: 'paymentReceived', header: 'Payment Received', width: 'auto' },
		{ field: 'locked', header: 'Locked?', width: 'auto' },
		{ field: 'balanced', header: 'Balanced?', width: 'auto' },
	];

	ngOnInit(): void {
		this.formBuild();
		this.loadShortTermRentals();
		this.fetchReservations();
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Lazy Load All Data
	 *
	 */
	// loadLazy(event: LazyLoadEvent) {
	// 	try {
	// 		this.loading = true;
	// 		this.lazyLoadEvent = event;

	// 		console.log(
	// 			' event.first:' + event.first
	// 			+ '  |  event.rows:' + event.rows
	// 			+ '  |  event.sortField:' + event.sortField
	// 			+ '  |  event.sortOrder:' + event.sortOrder
	// 			+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
	// 			+ '  |  event.globalFilter:' + event.globalFilter
	// 			+ '  |  event.filters:' + JSON.stringify(event.filters)
	// 		);

	// 		/*
	// 		*
	// 		* Default Sort
	// 		*/
	// 		// https://stackoverflow.com/questions/679915/how-do-i-compareWikiReservationLedger-for-an-empty-javascript-object
	// 		// if we are NOT filtering and we are NOT sorting, apply a default sort
	// 		if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
	// 			event.multiSortMeta = [];
	// 			event.multiSortMeta.push({ field: 'createDate', order: -1 });
	// 		}

	// 		const pageNumber = Math.round(event.first / event.rows);
	// 		this.compareReservationLedgerService.findByFilter(
	// 			pageNumber, event.rows,
	// 			event.sortField,
	// 			event.sortOrder,
	// 			event.multiSortMeta,
	// 			event.globalFilter,
	// 			event.filters).pipe(first()).subscribe(

	// 				(res: any) => {
	// 					this.datasource = res.data.reviews;
	// 					this.recordTotal = res.page.recordTotal;
	// 					this.compareWikiReservationLedgers = res.data.compareWikiReservationLedgers;
	// 					console.log(JSON.stringify(res.page));
	// 				},
	// 				(err: any) => {
	// 					console.log('reviews list error!: ' + JSON.stringify(err));
	// 					this.alertService.error(err);
	// 				},
	// 				() => { this.loading = false; }
	// 			);

	// 		if (this.datasource) {
	// 			this.compareWikiReservationLedgers = this.datasource.slice(event.first, (event.first + event.rows));
	// 		}
	// 	} catch (error) {
	// 		console.log('loadLazy(' + event + ')' + error);
	// 	}
	// }

	fetchReservations() {
		try {
			this.compareReservationLedgerService.compareReservationLedgerWithInvoice()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.reservations = res.data.reservations;
						return this.reservations;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {
						this.loading = false
					});
		} catch (error) {
			this.loading = false
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	synchReservationToYieldMax(reservationId: any) {
		const data ={
			reservationId: reservationId
		}
		try {
			this.compareReservationLedgerService.synchReservationToYieldMax(data)
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reservation sync successfully', life: 3000 });
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}
	syncReservationSLtoWiki(reservation: any) {
		let data =reservation
		try {
			if(data.slConfNumber && data.shortTermRentalId) {
				this.compareReservationLedgerService.syncReservationSLtoWiki(data)
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.messageService.add({
								severity: 'success',
								summary: 'Success',
								detail: 'Reservation sync successfully',
								life: 3000
							});
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => {
						});
			}else{

				this.alertService.error(data);

			}

		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error("Invalid reservation");
		}
	}

	getStatus() {
		return
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(compareWikiReservationLedger: CompareReservationLedger) {
		try {
			this.formLoading = true;
			this.compareReservationLedgerService.update(compareWikiReservationLedger)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.compareReservationLedgers.map((compareWikiReservationLedger, i) => {
							if (compareWikiReservationLedger.compareWikiReservationLedgerId === res.data.compareWikiReservationLedger.compareWikiReservationLedgerId) {
								this.compareReservationLedgers[i] = res.data.compareWikiReservationLedger;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.compareReservationLedgers ? this.first === (this.compareReservationLedgers.length - this.rows) : true; }
	isFirstPage(): boolean { return this.compareReservationLedgers ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(compareWikiReservationLedger: any) {
		if (compareWikiReservationLedger?.reservationStatus) {
			const status = this.reservationStatuses.find((e: any) => e.value == compareWikiReservationLedger.reservationStatus);
			return status.name;
		}
		else {
			return '';
		}
	}

	getResStatusName(resStatus)
	{
		let status = this.reservationStatuses.find(function (item) { return item.value === resStatus });
		if(status){
			this.reservationStatus1 = status.name;
			return status.name
		}else{
			return	resStatus
		}
	}

	getResStatusColor(resStatus)
	{
		let status = this.reservationStatuses.find(function (item) { return item.value === resStatus });
		if(status){
			return status.color
		}else{
			return	''
		}
	}


	getSyncColor(reservation: any){
		if(reservation.balanced){

			return 'rgba(0,128,0,0.35)'
			}
			return 'rgba(243,0,0,0.34)';

	}
	getDiscripancyAmt(reservation: any){
		if(!reservation.balanced){
			let amt = reservation.originalInvoiceTotal + (reservation.ledgerInvoiceTotal * -1);
			return amt;
		}
		return reservation?.ledgerTotal;

	}
	getLockColor(reservation: any){


		if(reservation.balanced){
			let total = Math.abs(reservation.ledgerTotal);
			if(total > 1){
				return 'rgba(243,0,0,0.34)';
			}

			return 'rgba(0,128,0,0.35)'
		}
		return 'rgba(243,0,0,0.34)';

	}
	getDiff(reservation: any){
		return Math.abs(reservation.subTotal + reservation.ledgerSubTotal);
	}


	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	removeNull(slConfNumber: any){
		return slConfNumber != 'null' ? slConfNumber : "";;
	}

	openInvoice(reservation: any) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		// To add new orderDetails, use reservationId, orderId to link FK

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Invoice Reservation#'+reservation.reservationId,

			showPagination : false,
			reservationId: reservation.reservationId,

			checkInDate: reservation.checkInDate,

			checkOutDate: reservation.checkOutDate,
			shortTermRentalId: reservation.shortTermRentalId,
			orderId: reservation.orderId,
			ruReservationId: reservation?.ruReservationId,

		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderDetailListComponent, dialogConfig);
		dialogRef.afterClosed().subscribe(() => {
			this.refresh(reservation)
		});
		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding

	}
	openLedger(reservation: any) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "95vw";
		dialogConfig.width = "95vw";
		dialogConfig.maxHeight = "87vh";
		dialogConfig.height = "87vh";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Reservation Ledgers',
			showFilter: true,
			showPagination: false,
			displayClose: false,
			isPopup: true,
			reservationId: reservation.reservationId

		};
		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ReservationLedgerListComponent, dialogConfig);

		dialogRef.afterClosed().subscribe(() => {
			this.refresh(reservation)
		});
		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding

	}


	generateLedgers(reservation: any) {
		this.compareReservationLedgerService.generateLedgers(reservation?.reservationId).subscribe(
			res => {
				this.alertService.success("Generate Ledger successfully for reservation#"+reservation?.reservationId);
				this.refresh(reservation)

			},
			err => {
				console.log('Feature-Update FAIL: ' + JSON.stringify(err));
				this.alertService.error(err);
			},
			() => {
				this.loading = false
			});
	}
	refresh(reservation: any) {

		try {
			this.compareReservationLedgerService.getReservationLedgerWithInvoice(reservation.reservationId)
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						let reservations = res.data.reservations;
						if(reservations && reservations.length > 0){
							let rev = reservations[0];
							let itemIndex = this.reservations.findIndex((item: any) => item.reservationId == rev.reservationId);
							console.log(itemIndex+ ' Old '+JSON.stringify(this.reservations[itemIndex]));

							this.reservations[itemIndex] = rev;
							console.log('New '+JSON.stringify(this.reservations[itemIndex]));


							// no idea what this is but it is required to update the array
							this.reservations = [...this.reservations];
						}

					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {
						this.loading = false
					});
		} catch (error) {
			this.loading = false
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			shortTermRentalIds:[],
			checkInDate:[],
			checkOutDate:[],
		});
	}

	loadShortTermRentals() {
		this.formLoading = true;
		this.reportService.propertySummaryList().pipe().subscribe(

			data => {
				this.shortTermRentals = data.data.propertySummaryList;
			},
			error => {
				console.log('reports LIST!: ' + JSON.stringify(error));
			},
			() => { this.formLoading = false; }
		);
	}
	onDateChange()
	{
		if (this.form1.get('checkInDate').value) {
			this.minDate = this.form1.get('checkInDate').value;
		}
	}

	//Search ledger
	formSearch()
	{
		this.loading = true;
		console.log(this.form1.value)
		let shortTermRentalIdList: Array<any> = [];
		if(this.form1.value)
		{
			if(this.form1.value.shortTermRentalIds)
			{
				this.form1.value.shortTermRentalIds.forEach(element => {
					shortTermRentalIdList.push(element.shortTermRentalId);
				});
			}
		}
		this.reservations.forEach(res => {
			res.hide = false;
			if(shortTermRentalIdList.length > 0)
			{
				if(res.shortTermRentalId && !shortTermRentalIdList.includes(res.shortTermRentalId))
				{
					res.hide = true;
				}
			}
			if(res.checkInDate && res.checkOutDate)
			{
				let checkInDate = new Date(res.checkInDate);
				let checkOutDate = new Date(res.checkOutDate);
				// Set both checkInDate and checkOutDate to 00:00:00 (midnight)
				checkInDate.setHours(0, 0, 0, 0);
				checkOutDate.setHours(0, 0, 0, 0);

				if(this.form1.value.checkInDate && !this.form1.value.checkOutDate)
				{
					this.form1.value.checkInDate.setHours(0, 0, 0, 0);
					const isBetween = this.isDateBetween(this.form1.value.checkInDate, checkInDate, checkOutDate);
					if(!isBetween)
					{
						res.hide = true;
					}
				}
				if(!this.form1.value.checkInDate && this.form1.value.checkOutDate)
				{
					this.form1.value.checkOutDate.setHours(0, 0, 0, 0);
					const isBetween = this.isDateBetween(this.form1.value.checkOutDate, checkInDate, checkOutDate);
					if(!isBetween)
					{
						res.hide = true;
					}
				}
				if(this.form1.value.checkInDate && this.form1.value.checkOutDate)
				{
					this.form1.value.checkInDate.setHours(0, 0, 0, 0);
					const isBetween = this.isDateBetweenDateRange(this.form1.value.checkInDate, this.form1.value.checkOutDate, checkInDate, checkOutDate);
					if(!isBetween)
					{
						res.hide = true;
					}
				}
			}
		});
		this.loading = false;
	}

	isDateBetween(dateToCheck: Date, startDate: Date, endDate: Date): boolean {
		return dateToCheck >= startDate && dateToCheck <= endDate;
	}
	isDateBetweenDateRange(startDateToCheck: Date, endDateToCheck: Date, checkInDate: Date, checkOutDate: Date)
	{
		if((startDateToCheck >= checkInDate && startDateToCheck < checkOutDate)
			|| (startDateToCheck <= checkInDate && endDateToCheck >= checkInDate)
		)
		{
			return true;
		}
		else
		{
			return false;
		}
	}
	protected readonly environment = environment;

	exportSelected($event: any) {
		this.importExportComponent.exporData($event, this.reservations, 'Compare Reservation Ledgers');
	  }
}
